module.exports = __webpack_public_path__ + "static/media/WorkOrder.f49a9bf2.svg";